import { useIntersectionObserver } from '@packages/shared/src/hooks/useIntersectionObserver/useIntersectionObserver';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';
import type { RefObject } from 'react';

type FlixmediaTrackingProps = {
  brandName: string;
  ref: RefObject<Element | null>;
};

export const useFlixmediaTracking = ({ brandName, ref }: FlixmediaTrackingProps) => {
  const dispatchTracking = useTracking();

  useIntersectionObserver(ref, {
    intersectOnce: true,
    threshold: 1,
    callback: (isIntersecting) => {
      if (!isIntersecting) {
        return;
      }
      // intersectOnce is set to true, so this callback will only be called once
      dispatchTracking<GTMEventGlycerinDisplayButton>({
        event: 'DisplayButton',
        DisplayButtonData: {
          category: `Herstellerinformation ${brandName}`,
          detail: 'Flixmedia',
          label: 'Content-Products',
        },
      });
    },
  });

  const trackFlixmediaClick = () => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: `Herstellerinformation ${brandName}`,
        detail: 'Flixmedia',
        label: 'Content-Products',
      },
    });
  };
  const trackFlixmediaDisplayOverlay = () => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: `Herstellerinformation ${brandName}`,
        detail: 'Flixmedia',
        label: 'Content-Products',
      },
    });
  };

  return {
    trackFlixmediaClick,
    trackFlixmediaDisplayOverlay,
  };
};
